/* 
功能分析
1，传入父级 元素，
2，指定子级在父级内移动
*/

import { getPosition, getScroll } from "@/assets/js/utils";
import { on } from "./dom";
class Move {
  constructor(option) {
    this.wrapEl = option.wrapEl;
    this.el = option.el;
    this.stop = false;
    this.scrollHeiht = option.scrollHeiht;
    // this.wrapEl.addEventListener("scroll", event => {
    //   this.mousemove(this.lastY, this.lastX);
    // });
    // this.wrapEl.addEventListener("mousemove", event => {
    //   this.mousemove(event.clientY, event.clientX);
    // });
    on(this.wrapEl, "scroll", () => {
      this.mousemove(this.lastY || 0, this.lastX || 0);
    });
    on(this.wrapEl, "mousemove", (event) => {
      this.mousemove(event.clientY, event.clientX);
    });
  }
  mousemove(clientY, clientX) {
    if (this.stop) return;
    let divY = clientY - getPosition(this.wrapEl).y + getScroll("scrollTop", this.wrapEl) - getPosition(this.el).height / 2;
    let divX = clientX - getPosition(this.wrapEl).x + getScroll("scrollLeft", this.wrapEl) - getPosition(this.el).width / 2;
    let maxWidth = getPosition(this.wrapEl).width - getPosition(this.el).width - 8;
    // let maxHeiht = getPosition(this.wrapEl).height - getPosition(this.el).height;
    if (divX < 0) {
      divX = 0;
    }
    if (divY < 0) {
      divY = 0;
    }
    if (divX > maxWidth) {
      divX = maxWidth;
    }

    if (divY > this.scrollHeiht - getPosition(this.el).height) {
      divY = this.scrollHeiht - getPosition(this.el).height;
    }
    this.setElPosition(divY, divX);
    this.lastY = clientY;
    this.lastX = clientX;
  }
  get getScrollInfo() {
    return {
      scrollTop: getScroll("scrollTop", this.wrapEl),
      scrollLeft: getScroll("scrollLeft", this.wrapEl),
    };
  }

  setElPosition(divY, divX) {
    this.el.style.top = divY + "px";
    this.el.style.left = divX + "px";
  }
  // getPosition(el: HTMLElement): { readonly width, readonly height, readonly x, readonly y } {
  //   let { width, height, x, y } = el.getBoundingClientRect()
  //   return { width, height, x, y }
  // }
  // // 获取滚动条距离
  // getScroll(direction: ScrollDirection, el?: HTMLElement) {
  //   if (el) {
  //     return el[direction] || el[direction]
  //   }
  //   return document.body[direction] || document.documentElement[direction]
  // }
}

export default Move;
